import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { SearchServiceItem } from "./lib";
import { searchServiceItems } from "./lib";
import { storage } from "@/lib/storage";

type SearchState = {
  recentSearches: SearchServiceItem[];
  isOnSearch: boolean;
  nativeQueryParams: string;
};

export const useSearchStore = create(
  persist<
    SearchState & {
      addRecentSearch: (search: SearchServiceItem) => void;
      removeRecentSearch: (search: SearchServiceItem) => void;
      clearRecentSearches: () => void;
      setIsOnSearch: (isOnSearch: boolean) => void;
      setNativeQueryParams: (query: string) => void;
    }
  >(
    (set, get) => ({
      recentSearches: [],
      isOnSearch: false,
      nativeQueryParams: "",
      addRecentSearch: (search: SearchServiceItem) => {
        const { recentSearches } = get();
        const filteredSearches = recentSearches.filter(
          (existingSearch) => existingSearch.title !== search.title,
        );
        const updatedSearches = [search, ...filteredSearches].slice(0, 3);
        set({ recentSearches: updatedSearches });
      },
      removeRecentSearch: (search: SearchServiceItem) => {
        const { recentSearches } = get();
        const updatedSearches = recentSearches.filter(
          (existingSearch) => existingSearch.title !== search.title,
        );
        set({ recentSearches: updatedSearches });
      },
      clearRecentSearches: () => {
        set({ recentSearches: [] });
      },
      setIsOnSearch: (isOnSearch: boolean) => {
        set({ isOnSearch: isOnSearch });
      },
      setNativeQueryParams: (nativeQueryParams: string) => {
        set({ nativeQueryParams: nativeQueryParams });
      },
    }),
    {
      name: "search-storage",
      storage,
      onRehydrateStorage: () => (state) => {
        if (state?.recentSearches?.length) {
          const allServices = searchServiceItems();
          const updatedRecent = state.recentSearches.filter((recent) =>
            allServices.some((item) => item.title === recent.title),
          );
          state.recentSearches = updatedRecent;
        }
      },
    },
  ),
);
